import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion/dist/framer-motion';
import classnames from 'classnames';
import { slugify } from '@utils'
const hoverintent = require('hoverintent');
import { SubMenu } from './SubMenu'

export const MenuItem = ({ ctx, link, level, path, highlight }) => {

  const itemRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [hasSubmenu, setHasSubmenu] = useState(link.links && level < 2)

  let is_mega = false;

  link.links?.forEach(l => {
    if (l.links) {
      is_mega = true
    }
  });

  const optionClasses = classnames('Nav__item', `level-${level}`, {
    'is-active': link.active,
    'is_mega': is_mega && level == 1,
    'is_simple': !is_mega && level == 1,
    'u-hidden': link.object_handle == 'flag-how-to-videos' && level == 2
  });

  const handleClick = (e) => {
    if (hasSubmenu) {
      if (!isOpen) {
        e.preventDefault();
      }
      ctx.emit('toggleMenuItem', { type: 'menu-item', identifier: slugify(link.title) })
    }
  };

  const handleFocus = (e) => {
    if (hasSubmenu) {
      if (e.type == 'keyup' && e.code == 'Tab') {
        if (!isOpen) {
          ctx.emit('toggleMenuItem', { type: 'menu-item', identifier: slugify(link.title) })
        }
      }
      if (e.type == 'blur') {
        if (!itemRef.current.contains(e.relatedTarget)) {
          ctx.emit('toggleMenuItem', { type: 'menu-item', identifier: null })
        }
      }
    }

  };

  useEffect(() => {
    if (hasSubmenu) {
      ctx.on('toggleMenuItem', state => {
        if (state.identifier == slugify(link.title)) {
          setIsOpen(true)
        } else {
          setIsOpen(false)
        }
      });

      if (!window.matchMedia("(any-hover: none)").matches) {
        let timeoutId
        hoverintent(
          itemRef.current,
          () => ctx.emit('toggleMenuItem', { type: 'menu-item', identifier: slugify(link.title) }),
          () => ctx.emit('toggleMenuItem', { type: 'menu-item', identifier: null }),
          {
            timeout: 5000,
            interval: 5000,
          }
        )
      }
    }
  }, [])

  const variants = {
    open: { opacity: 1, height: 'auto' },
    closed: { opacity: 0, height: 0 },
  }

  return (

    <div className={optionClasses} ref={itemRef} onBlur={handleFocus}>
      <motion.a initial={false} onClick={e => handleClick(e)} onKeyUp={handleFocus} href={link.url} className={`Nav__link level-${level} ${level != 1 && link.url == '#' && 'anchor-link'}`}>
        <span>{link.title}</span>
      </motion.a>
      {
        link.links && (
          <AnimatePresence initial={level == 1 ? false : true}>

            <motion.div
              key="content"
              initial={level == 1 ? 'closed' : 'open'}
              animate={isOpen || level > 1 ? "open" : "closed"}
              exit="closed"
              variants={variants}
              transition={{ duration: 0.6, ease: [0.04, 0.62, 0.23, 0.98] }}
              className={`Nav__submenu level-${level} ${highlight ? 'has-highlight' : ''}`}
              data-identifier={slugify(link.title)}
            >
              {level == 1 && is_mega
                ? (<div data-container='narrow'>
                  <SubMenu ctx={ctx} items={link.links} level={level} path={path} isMega={is_mega} title={link.title} highlight={highlight}></SubMenu>
                </div>)
                : <SubMenu ctx={ctx} items={link.links} level={level} path={path}></SubMenu>
              }

            </motion.div>

          </AnimatePresence>
        )
      }
    </div >

  );
};